import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';

const primaryMenuItems = accountId => [
  {
    icon: 'chat',
    key: 'conversations',
    label: 'CONVERSATIONS',
    toState: frontendURL(`accounts/${accountId}/dashboard`),
    toStateName: 'home',
  },
  {
    icon: 'chat-multiple',
    key: 'internal_chat',
    label: 'INTERNAL_CHAT',
    featureFlag: FEATURE_FLAGS.INTERNAL_CHAT,
    toState: frontendURL(`accounts/${accountId}/internal-chat`),
    toStateName: 'internal_chat',
  },
  {
    icon: 'book-contacts',
    key: 'contacts',
    label: 'CONTACTS',
    featureFlag: FEATURE_FLAGS.CRM,
    toState: frontendURL(`accounts/${accountId}/contacts`),
    toStateName: 'contacts_dashboard',
  },
  {
    icon: 'arrow-trending-lines',
    key: 'reports',
    label: 'REPORTS',
    featureFlag: FEATURE_FLAGS.REPORTS,
    toState: frontendURL(`accounts/${accountId}/reports`),
    toStateName: 'account_overview_reports',
  },
  {
    icon: 'megaphone',
    key: 'campaigns',
    label: 'CAMPAIGNS',
    featureFlag: FEATURE_FLAGS.WHATSAPP_CAMPAIGNS,
    toState: frontendURL(`accounts/${accountId}/campaigns`),
    toStateName: 'campaigns_whatsapp_index',
  },
  {
    icon: 'task-list',
    key: 'kanban',
    label: 'Kanban',
    featureFlag: FEATURE_FLAGS.KANBAN,
    toState: frontendURL(`accounts/${accountId}/kanban`),
    toStateName: 'kanban',
  },
  {
    icon: 'bot',
    key: 'typebot',
    label: 'TYPEBOT',
    hasSubMenu: false,
    meta: {
      permissions: ['administrator'],
    },
    toState: frontendURL(`accounts/${accountId}/settings/robos/list`),
    toStateName: 'robo_list',
    activeOn: ['robo_wrapper', 'robo_list'],
    featureFlag: FEATURE_FLAGS.TYPEBOT,
  },
  {
    icon: 'settings',
    key: 'settings',
    label: 'SETTINGS',
    toState: frontendURL(`accounts/${accountId}/settings`),
    toStateName: 'settings_home',
  },
];

export default primaryMenuItems;
